import React, { FC } from 'react'
import { Tab } from '@headlessui/react'
import { useGiveawayContext } from '../../../context/GiveawayContext'
import { TabContent } from '../TabContent'

export const TabPanels: FC = () => {
  const { content } = useGiveawayContext()
  const tabs = content.tabsCollection?.items || []
  return (
    <Tab.Panels className="w-full">
      {tabs.map((tab) => (
        <Tab.Panel key={tab?.sys.id} className="w-full">
          <TabContent tab={tab} />
        </Tab.Panel>
      ))}
    </Tab.Panels>
  )
}
